import "core-js/modules/es.array.filter";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import NavigationContext from 'wfui-digital-core/es/NavigationContext';
import Block from 'wfui-digital-core/es/Block';
import Search from './search/Search';
import Enroll from './enroll/Enroll';
import styles from './Header.less';

var Header = function Header() {
  var _useContext = useContext(NavigationContext),
      getContainer = _useContext.getContainer;

  var links = getContainer('HAMBURGER_MENU').sections[0].links;
  var searchLink = links.filter(function (link) {
    return link.navigationId === 'SEARCH';
  })[0];
  var enrollLink = links.filter(function (link) {
    return link.navigationId === 'ENROLL';
  })[0];
  return searchLink && enrollLink ? /*#__PURE__*/React.createElement(Block, {
    px: "b",
    layout: true,
    horizontal: true,
    className: styles.header
  }, /*#__PURE__*/React.createElement(Block, {
    flex: true,
    start: true
  }, /*#__PURE__*/React.createElement(Search, null)), /*#__PURE__*/React.createElement(Enroll, null)) : null;
};

export default Header;